<template>
  <div>
    <v-navigation-drawer v-model="drawer" app temporary dark color="accent">
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="@/assets/logo.png" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">Almeida</v-list-item-title>
            <v-list-item-subtitle>Technologies</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content> </v-list-item
        ><v-divider></v-divider>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app :color="color" :flat="flat" dark :class="{ expand: flat }">
      <v-toolbar-title>
        <v-img src="@/assets/logo_branca.png" max-width="250px" />
      </v-toolbar-title>
      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn text @click="$vuetify.goTo('#quemsomos')"> Quem Somos </v-btn>
        <v-btn text @click="$vuetify.goTo('#produtos')"> Produtos </v-btn>
        <v-btn text @click="$vuetify.goTo('#noticias')"> Notícias </v-btn>
        <v-btn outlined rounded @click="$vuetify.goTo('#contactus')">
          Fale Conosco
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}
</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["Quem Somos", "#quemsomos"],
      ["Produtos", "#produtos"],
      ["Notícias", "#noticias"],
      ["Fale Conosco", "#contactus"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>
